// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ReopenInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/reopen_employee_deduction/{id} and POST /payroll/reopen_employee_advance/{id}
 *
 * Validates input for reopening a canceled deduction or advance.
 * Shared contract for both deduction and advance reopen endpoints.
 */
import { registerContract } from './validate'

export interface Payroll_ReopenInput {
target_status?: string
}

registerContract('Payroll_ReopenInput', {
  target_status: { type: 'string',  required: false },
})
